<template>
  <div class="app-container">
    <div class="title">
      <div class="title--font">
        {{ topTitle }}
      </div>
      <div class="title--button">
        <el-button type="primary" size="small" @click="openAdd({}, 0)">
          新增
        </el-button>
        <myExportExcel
          :excelTitleList="titleList"
          :idsList="exportIdsList"
          :url="OUTSOURCING_EXPORT_URL.PRODUCT_FINISH"
          :filter="searchData"
          :excelName="'产品委外出货'"
        />
        <printViewBtn
          :changeList="changeList"
          :modules="OUTSOURCING_PRINT_MODULES.PRODUCT_FINISH"
          :printFun="outsourcingtowarehouse_view"
          :allowLabelPrint="true"
        />
      </div>
    </div>
    <hr />
    <div class="delivery-stat" v-loading="statLoading">
      <el-row :gutter="16">
        <el-col
          v-for="item in statCards"
          :key="item.key"
          :xs="24"
          :sm="12"
          :md="6"
        >
          <div class="delivery-stat__card">
            <div class="delivery-stat__left">
              <span class="delivery-stat__title">{{ item.title }}</span>
              <div v-if="item.desc" class="delivery-stat__desc">{{ item.desc }}</div>
            </div>
            <div class="delivery-stat__count" :style="{ color: item.color }">
              {{ item.count }}
            </div>
          </div>
        </el-col>
      </el-row>
    </div>
    <my-operate
      :id="'myOperate'"
      :titleList="titleList"
      :operationTitleData="operationTitleData"
      :titleOperationTitleData="titleOperationTitleData"
      :titleData="searchData"
      @titleOperationBtnClick="titleOperationBtnClick"
      @operationBtnClick="operationBtnClick"
      @onStart="onStart"
      @onEnd="onEnd"
      @isShowClick="isShowClick"
      @widthClick="widthClick"
      @resetClick="resetClick"
      ref="myOperate"
    >
    </my-operate>
    <myHtml
      v-loading="listLoading"
      :height="tableContentHeight"
      :id="'bill_one'"
      :columnType="columnType"
      :list="list"
      :titleList="titleList"
      :tableBtnList="tableBtnList"
      :checkKey="'outsourcingtowarehouseId'"
      :keyData="['outsourcingtowarehouseId']"
      @btnClick="btnClick"
      @cellClickEvent="cellClickEvent"
      @resizableChange="resizableChange"
      @selectChangeEvent="selectChangeEvent"
      @selectAllCheckboxChange="selectAllCheckboxChange"
      ref="myTable"
    ></myHtml>
    <pagination
      :total="listQuery.total"
      :page.sync="listQuery.pageNum"
      :limit.sync="listQuery.pageSize"
      :page-sizes="[10, 20, 50, 100, 300]"
      style="text-align: right; float: right"
      @pagination="getList"
    />
    <div style="clear: both"></div>
    <myOrderAdd
      v-if="htmlDataDialogState.show1"
      :visible="htmlDataDialogState.show1"
      :homeIndex="homeIndex"
      :routeType="routeType"
      :routeQuery="routeQuery"
      @htmlDataDialogClose="htmlDataDialogClose"
    ></myOrderAdd>
    <myOrderDetails
      v-if="htmlDataDialogState.show2"
      :visible="htmlDataDialogState.show2"
      :homeIndex="homeIndex"
      :routeQuery="routeQuery"
      @htmlDataDialogClose="htmlDataDialogClose"
    ></myOrderDetails>
  </div>
</template>
<script>
import {
  outsourcingtowarehouse_getVagueList,
  outsourcingtowarehouse_getDeliveryStat,
  outsourcingtowarehouse_delete,
  outsourcingtowarehouse_view,
} from "@/api/myController/outsourcing";
import { normalizeDeliveryStat } from "@/utils/outsourcingFinishDelivery";
import { OUTSOURCING_PRINT_MODULES } from "@/utils/outsourcingPrint";
import {
  OUTSOURCING_EXPORT_URL,
  buildExportIdsList,
} from "@/utils/outsourcingExport";

export default {
  name: "outsourcingProduct_finish",
  props: {
    titleData: {
      type: Object,
      default: () => ({}),
    },
  },
  data() {
    return {
      htmlDataDialogState: {
        show1: false,
        show2: false,
        show3: false,
      },
      routeType: 0,
      routeQuery: {},
      homeIndex: 50,
      OUTSOURCING_PRINT_MODULES,
      OUTSOURCING_EXPORT_URL,
      outsourcingtowarehouse_view,
      topTitle: "产品委外出货",
      listQuery: {
        total: 0,
        pageNum: 1,
        pageSize: 20,
      },
      changeList: [],
      searchData: {
        searchString: "",
      },
      operationTitleData: [],
      orderParam: {
        asc: false,
        dateAggregateBy: "",
        fieldName: "createTime",
      },
      titleOperationTitleData: [
        {
          name: "综合查询",
          value: "searchString",
          type: "text",
        },
        { name: "搜索", type: "button" },
        { name: "重置", type: "button" },
      ],
      listLoading: false,
      statLoading: false,
      statCards: normalizeDeliveryStat(),
      columnType: "columnAll",
      tableBtnList: ["详情", "删除"],
      list: [],
      titleList: [
        {
          id: 1,
          name: "委外订单号",
          value: "baseOutsourcingDocNumber",
          fixedState: false,
          isShow: true,
          dataType: "text",
          canEdit: false,
          width: 130,
        },
        {
          id: 2,
          name: "出货单号",
          value: "outsourcingtowarehouseNumber",
          fixedState: false,
          isShow: true,
          dataType: "text",
          alwaysEditState: false,
          canEdit: false,
          color: "#1476c3",
          width: 150,
        },
        // {
        //   id: 0,
        //   name: "全局搜索码",
        //   value: "globalSearchNumber",
        //   fixedState: false,
        //   isShow: true,
        //   dataType: "text",
        //   canEdit: false,
        //   width: 120,
        //   sortable: true,
        // },
        {
          id: 0,
          name: "委外商",
          value: "baseOutsourcingSupplierName",
          fixedState: false,
          isShow: true,
          dataType: "text",
          canEdit: false,
          width: 120,
          sortable: true,
        },
        {
          id: 6,
          name: "产品编号",
          value: "baseMaterialNumber",
          fixedState: false,
          isShow: true,
          dataType: "text",
          canEdit: false,
          width: 120,
        },
        {
          id: 7,
          name: "产品名称",
          value: "baseMaterialName",
          fixedState: false,
          isShow: true,
          dataType: "text",
          canEdit: false,
          width: 120,
        },
        {
          id: 8,
          name: "规格",
          value: "specifications",
          fixedState: false,
          isShow: true,
          dataType: "textList",
          canEdit: false,
          width: 180,
        },
        {
          id: 2,
          name: "客户料号",
          value: "baseCustomerMaterialNumber",
          fixedState: false,
          isShow: true,
          dataType: "text",
          canEdit: false,
          width: 120,
        },
        {
          id: 9,
          name: "本次出货数量",
          value: "baseOutsourcingFinishedQuantity",
          fixedState: false,
          isShow: true,
          dataType: "number",
          canEdit: false,
          width: 120,
        },
        {
          id: 14,
          name: "审核状态",
          value: "statusCheck",
          fixedState: false,
          isShow: true,
          dataType: "customSelect",
          selectOptionList: [
            {
              label: "已审核",
              value: 1,
              color: "white",
              backGroundColor: "rgb(103,194,58)",
              fontSize: "",
            },
            {
              label: "未审核",
              value: 0,
              color: "black",
              backGroundColor: "rgb(220,223,230)",
              fontSize: "",
            },
          ],
          canEdit: false,
          width: 90,
        },
        {
          id: 15,
          name: "出库状态",
          value: "statusOutwarehouse",
          fixedState: false,
          isShow: true,
          dataType: "customSelect",
          selectOptionList: [
            {
              label: "已出库",
              value: 1,
              color: "white",
              backGroundColor: "rgb(103,194,58)",
              fontSize: "",
            },
            {
              label: "未出库",
              value: 0,
              color: "black",
              backGroundColor: "rgb(220,223,230)",
              fontSize: "",
            },
          ],
          canEdit: false,
          width: 90,
        },
        // {
        //   id: 0,
        //   name: "出货日期",
        //   value: "baseInwarehouseTime",
        //   fixedState: false,
        //   isShow: true,
        //   dataType: "dateTime",
        //   canEdit: false,
        //   width: 120,
        // },
        {
          id: 11,
          name: "操作人",
          value: "createUserName",
          fixedState: false,
          isShow: true,
          dataType: "text",
          canEdit: false,
          width: 120,
        },
        {
          id: 11,
          name: "备注",
          value: "remark",
          fixedState: false,
          isShow: true,
          dataType: "textarea",
          canEdit: false,
          width: 120,
        },
      ],
    };
  },
  computed: {
    tableContentHeight() {
      const rootHeight = Number(this.$root.tableHeight) || 600;
      // 基础偏移 50 + 顶部统计卡片区域约 110
      return Math.max(rootHeight - 160, 280);
    },
    exportIdsList() {
      return buildExportIdsList(this.changeList, "outsourcingtowarehouseId");
    },
  },
  created() {
    this.searchData = { ...this.searchData, ...this.titleData };
    const query = this.$route.query || {};
    if (query.outsourcingDocNumber) {
      this.searchData.searchString = query.outsourcingDocNumber;
    }
    this.getDeliveryStat();
    this.getList();
  },
  methods: {
    getDeliveryStat() {
      this.statLoading = true;
      outsourcingtowarehouse_getDeliveryStat({
        outsourcingtowarehouseFilter: this.buildFilter(),
      })
        .then((res) => {
          this.statCards = normalizeDeliveryStat(res.data.data || {});
        })
        .catch(() => {
          this.statCards = normalizeDeliveryStat({});
        })
        .finally(() => {
          this.statLoading = false;
        });
    },
    buildFilter() {
      const filter = {};
      const data = this.searchData || {};
      if (data.searchString) {
        filter.searchString = data.searchString;
      }
      return filter;
    },
    normalizeListItem(item) {
      if (
        item.statusOutwarehouse === undefined &&
        item.status_outwarehouse !== undefined
      ) {
        item.statusOutwarehouse = item.status_outwarehouse;
      }
      try {
        item.specifications = JSON.parse(item.baseSpecgroupDesc);
      } catch (error) {
        item.specifications = [];
      }
      try {
        if (item.baseBomVersion) {
          item.baseBomVersionV2 = "V" + item.baseBomVersion;
        } else {
          item.baseBomVersionV2 = "---";
        }
      } catch (error) {}
      return item;
    },
    getList() {
      this.listLoading = true;
      outsourcingtowarehouse_getVagueList({
        orderParam: [this.orderParam],
        outsourcingtowarehouseFilter: this.buildFilter(),
        pageParam: this.listQuery,
      })
        .then((res) => {
          const pageData = res.data.data || {};
          const dataList = pageData.dataList || [];
          this.list = dataList.map((item) => this.normalizeListItem(item));
          this.listQuery.total = pageData.totalCount || 0;
          this.listLoading = false;
          this.$refs.myOperate?.dragSortShow();
        })
        .catch(() => {
          this.list = [];
          this.listQuery.total = 0;
          this.listLoading = false;
        });
    },
    openAdd(routeQuery = {}, routeType = 0) {
      this.routeQuery = routeQuery;
      this.routeType = routeType;
      this.homeIndex = 50;
      this.htmlDataDialogState.show1 = true;
    },
    async titleOperationBtnClick(item, titleData) {
      switch (item.name) {
        case "搜索":
          this.listQuery.pageNum = 1;
          this.getDeliveryStat();
          this.getList();
          break;
        case "重置":
          this.searchData = { searchString: "" };
          this.listQuery.pageNum = 1;
          this.getDeliveryStat();
          this.getList();
          break;
        default:
          break;
      }
    },
    operationBtnClick(item, titleData) {
      this.titleOperationBtnClick(item, titleData);
    },
    async btnClick(row, item) {
      switch (item) {
        case "详情":
          this.routeQuery = row;
          this.homeIndex = 50;
          this.htmlDataDialogState.show2 = true;
          break;
        case "删除":
          if (row.statusCheck == 1) {
            this.$message.info("已审核状态不能删除");
            return;
          }
          this.$confirm("确定删除该出货单？", "提示", {
            confirmButtonText: "确定",
            cancelButtonText: "取消",
            type: "warning",
          })
            .then(() => {
              return outsourcingtowarehouse_delete({
                outsourcingtowarehouseId: row.outsourcingtowarehouseId,
              });
            })
            .then(() => {
              this.$message.success("操作成功");
              this.getDeliveryStat();
              this.getList();
            })
            .catch((err) => {
              if (err === "cancel") {
                this.$message.info("已取消删除");
              }
            });
          break;
        default:
          break;
      }
    },
    cellClickEvent(row, column) {
      if (column.field === "outsourcingtowarehouseNumber") {
        this.routeQuery = row;
        this.homeIndex = 50;
        this.htmlDataDialogState.show2 = true;
      }
    },
    selectChangeEvent(val) {
      this.changeList = val.records;
    },
    selectAllCheckboxChange(val) {
      this.changeList = val.records;
    },
    htmlDataDialogClose() {
      this.htmlDataDialogState.show1 = false;
      this.htmlDataDialogState.show2 = false;
      this.htmlDataDialogState.show3 = false;
      this.routeType = 0;
      this.routeQuery = {};
      this.getDeliveryStat();
      this.getList();
    },
    resizableChange(val) {
      this.titleList.forEach((item) => {
        if (item.value == val.field && item.name == val.title) {
          item.width = val.renderWidth;
        }
      });
    },
    onStart() {},
    onEnd(titleList) {
      this.titleList = titleList;
    },
    isShowClick(titleList) {
      this.titleList = titleList;
    },
    widthClick(titleList) {
      this.titleList = titleList;
    },
    async resetClick(titleList) {
      this.titleList = titleList;
    },
  },
};
</script>

<style rel="stylesheet/scss" lang="scss" scoped>
.title {
  display: flex;
  position: relative;
  margin-bottom: 10px;
}

.title--font {
  text-align: left;
  padding: 10px 0;
}

.title--button {
  position: absolute;
  right: 0;
  margin-top: 0.7%;
}

.delivery-stat {
  margin-bottom: 16px;
}

.delivery-stat__card {
  display: flex;
  align-items: center;
  justify-content: space-between;
  min-height: 84px;
  padding: 16px 18px;
  background: #f7f9fc;
  border: 1px solid #ebeef5;
  border-radius: 8px;
  margin-bottom: 16px;
}

.delivery-stat__left {
  flex: 1;
  min-width: 0;
  padding-right: 12px;
}

.delivery-stat__title {
  display: block;
  color: #303133;
  font-size: 14px;
  font-weight: 600;
  line-height: 1.4;
  margin-bottom: 6px;
}

.delivery-stat__desc {
  color: #909399;
  font-size: 12px;
  line-height: 1.5;
}

.delivery-stat__count {
  flex-shrink: 0;
  font-size: 32px;
  font-weight: 700;
  line-height: 1;
}

::v-deep .operation {
  margin-bottom: 10px;
}
::v-deep .el-input--mini .el-input__inner {
  height: 34px;
  line-height: 34px;
}
::v-deep .el-pagination span:not([class*="suffix"]),
.el-pagination button {
  display: inline-block;
  font-size: 13px;
  min-width: 35.5px;
  height: 34px;
  line-height: 34px;
  vertical-align: top;
  box-sizing: border-box;
}
::v-deep .el-pagination__editor.el-input .el-input__inner {
  height: 34px;
}
::v-deep .el-pagination.is-background .btn-prev {
  min-width: 34px;
}
::v-deep .el-pagination button {
  height: 34px;
  line-height: 34px;
}
::v-deep .el-pagination.is-background .el-pager li {
  min-width: 34px;
}
::v-deep .el-pager li {
  height: 34px;
  line-height: 34px;
}
</style>
